exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Modal__regionReportModal__UQqbd {\n  padding: 0;\n  border-radius: 5px;\n}\n\n.dmb-web__Modal__enhancedScoutingModal__2T-4w, .dmb-web__Modal__scoutingModal__58X7a {\n  padding: 0;\n}\n\n.dmb-web__Modal__enhancedScoutingModal__2T-4w {\n  margin-top: 2dvh;\n}\n", ""]);

// exports
exports.locals = {
	"regionReportModal": "dmb-web__Modal__regionReportModal__UQqbd",
	"enhancedScoutingModal": "dmb-web__Modal__enhancedScoutingModal__2T-4w",
	"scoutingModal": "dmb-web__Modal__scoutingModal__58X7a"
};